import styled from 'styled-components';

import { getRgba, colorRgb, zIndex } from 'app/shared/styles_js/variables';

import { GridRowSt, GridColSt, GridContainerSt } from '../Grid.css';

export const GridContainerDemoSt = styled(GridContainerSt)`
  font-size: 0.8em;
  word-break: break-all;

  ${GridColSt} {
    > div {
      border: 1px solid ${getRgba(colorRgb.brandPrimary, 0.2)};
      background-color: ${getRgba(colorRgb.brandPrimary, 0.15)};
    }
  }
`;

export const GridContainerDebugSt = styled(GridContainerSt)`
  height: 100%;

  ${GridRowSt} {
    height: 100%;
  }
`;

// overlay for debugging
export const GridOverlaySt = styled.div`
  position: fixed;
  z-index: ${zIndex.navbar + 5};

  width: 100%;
  height: 100%;
  opacity: 0.4;
  pointer-events: none;

  .debug-col-1 > div {
    height: 100%;
    background-color: #0088c6;
  }
`;
